import { useQuery } from "@tanstack/react-query";
import { useRestClient } from "../../api/RestClientContext";

export function useGetServers(isInternal: boolean) {

    const client = useRestClient();

	const query = useQuery({
		queryKey: ['servers'],
		queryFn: isInternal ? client.getServersInternal : client.getServers,
		retry: false, 
	});

	return {
		servers: query.data,
		isLoading: query.isLoading,
		error: query.error,
	};

}